/** Shared map pin selection treatment — orange glow on the active place. */

export const MAP_SELECTION_GLOW =
  "drop-shadow(0 0 3px #FF9000) drop-shadow(0 0 6px #FF9000) drop-shadow(0px -1px 4px #FF9000)";

export const MAP_SELECTION_COLOR = "#FF9000";

/** Build CSS filter for a selectable map marker. */
export function mapMarkerSelectionFilter(
  selected: boolean,
  unselectedFilter = "none"
): string {
  return selected ? MAP_SELECTION_GLOW : unselectedFilter;
}
